import { Text, VFlow } from 'bold-ui'
import { HLabel } from 'components/HLabel'
import { EvolucaoPlanoCiap, EvolucaoPlanoCid11 } from 'graphql/types.generated'
import HistoricoDetailTable from 'view/atendimentos/detail/historico/components/table/HistoricoDetailTable'

import { getHistoricoPlanoIntervencoesOrdenadas, getLabelTerminologia } from './utils-historicoPlano'

interface HistoricoPlanoPecIntervencoesProcedimentosPanelProps {
  intervencoesProcedimentos?: ReadonlyArray<EvolucaoPlanoCiap> | null
  cids11?: ReadonlyArray<EvolucaoPlanoCid11> | null
}

export default function HistoricoPlanoPecIntervencoesProcedimentosPanel({
  intervencoesProcedimentos,
  cids11,
}: Readonly<HistoricoPlanoPecIntervencoesProcedimentosPanelProps>) {
  const itens = getHistoricoPlanoIntervencoesOrdenadas(intervencoesProcedimentos, cids11)

  return (
    <HistoricoDetailTable hasLines>
      <VFlow vSpacing={0}>
        {itens.map(({ id, descricao, codigo, terminologia, nota }) => {
          const labelTerminologia = getLabelTerminologia(terminologia, codigo)
          return (
            <VFlow key={id} vSpacing={0}>
              <Text>
                {descricao} - {codigo}
                {labelTerminologia && ` (${labelTerminologia})`}
              </Text>
              {nota && <HLabel title='Observações:'>{nota}</HLabel>}
            </VFlow>
          )
        })}
      </VFlow>
    </HistoricoDetailTable>
  )
}
